import { createAction } from '@reduxjs/toolkit';

// ORDER SUMMARY ACTIONS
export const getOrderSummaryRequest = createAction('GET_ORDER_SUMMARY_REQUEST', (startDate, endDate, merchantId, storeID) => {
    return{
        payload: {
			startDate,
			endDate,
			merchantId,
			storeID
        }
    }
});

export const getOrderSummarySuccess = createAction('GET_ORDER_SUMMARY_SUCCESS', data => {
    return{
        payload: {
			data
        }
    }
});
export const getOrderSummaryFailure = createAction('GET_ORDER_SUMMARY_FAILURE', error => {
    return{
        payload: {
			error
        }
    }
});

// ORDER HISTORY ACTIONS
export const getOrderHistoryRequest = createAction('GET_ORDER_HISTORY_REQUEST', (startDate, endDate, merchantId, searchTerm, data) => {
    return{
        payload: {
			startDate,
			endDate,
			merchantId,
			searchTerm,
			data
        }
    }
});

export const getOrderHistorySuccess = createAction('GET_ORDER_HISTORY_SUCCESS', data => {
    return{
        payload: {
			data
        }
    }
});
export const getOrderHistoryFailure = createAction('GET_ORDER_HISTORY_FAILURE', error => {
    return{
        payload: {
			error
        }
    }
});


export const getOrderDownloadRequest = createAction('GET_ORDER_DOWNLOAD_REQUEST', (startDate, endDate, merchantId, searchTerm, data, selectionValue) => {
    return{
        payload: {
			startDate,
			endDate,
			merchantId,
			searchTerm,
			data,
            selectionValue
        }
    }
});

export const getOrderDownloadSuccess = createAction('GET_ORDER_DOWNLOAD_SUCCESS', data => {
    return{
        payload: {
			data
        }
    }
});
export const getOrderDownloadFailure = createAction('GET_ORDER_DOWNLOAD_FAILURE', error => {
    return{
        payload: {
			error
        }
    }
});
export const clearDownloadTypeData = createAction('CLEAR_DOWNLOAD_TYPES_DATA', clear => {
    return{
        payload: {
			clear
        }
    }
});
